import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { Stack } from '@mui/material';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function BarChart({ data, height, width, grid = false, barPercentage = 0.5 , borderRadius = 0 }) {
	const graphOptions = {
		barPercentage,  // Adjust the width of the bars
		responsive: true,
		maintainAspectRatio: false, // Allow chart to fill container height
		plugins: {
			legend: {
				display: false,
				position: 'top',
			},
		},
		scales: {
			x: {
				ticks: {
					display: true,  // Show x-axis labels
				},
				grid: {
					drawBorder: grid,
					display: false,
					color: '#edf2f5',
				},
				border: {
					display: true,
				},
			},
			y: {
				ticks: {
					display: true,
				},
				grid: {
					drawBorder: false,
					display: grid,
					color: '#edf2f5',
				},
				border: {
					display: true,
				},
			},
		},
	};
	return (
		<Stack sx={{ width: width, height: height }}> {/* Use dynamic height and width */}
			<Bar options={graphOptions} data={data} />
		</Stack>
	);
}
